import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Video, ResizeMode } from 'expo-av';
import { Ionicons } from '@expo/vector-icons';

interface Props {
  uri: string;
  aspectRatio?: { width: number; height: number };
  style?: any;
}

const VideoEmbed: React.FC<Props> = ({ uri, aspectRatio, style }) => {
  const ratio = aspectRatio && aspectRatio.width > 0 && aspectRatio.height > 0
    ? aspectRatio.width / aspectRatio.height
    : 16 / 9;

  return (
    <View style={[styles.container, { aspectRatio: ratio }, style]}>
      <Video
        source={{ uri }}
        style={StyleSheet.absoluteFill}
        resizeMode={ResizeMode.COVER}
        shouldPlay={false}
        isMuted
      />
      <View style={styles.playIconOverlay} pointerEvents="none">
        <Ionicons name="play" size={36} color="white" />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    backgroundColor: '#000',
    borderRadius: 12,
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
  },
  playIconOverlay: {
    position: 'absolute',
    backgroundColor: 'rgba(0,0,0,0.35)',
    borderRadius: 40,
    padding: 12,
  },
});

export default React.memo(VideoEmbed);
